module.exports = __webpack_public_path__ + "img/desc-top-e.ea601ba7.png";